<template>
  <div class="businessEntitySettings">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="container">
          <div class="left">
            <div class="list-item">
              {{ $t.businessEntity.companyName }}：{{ item.CompanyName }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.region }}：{{ item.RegisteredRegion }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.address }}：{{ item.RegisteredAddress }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.englishName }}：{{ item.EnglishName }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.foreignLanguageName }}：{{ item.ForeignLanguageName }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.establishmentDate }}：{{ item.EstablishmentDate }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.legalPerson }}：{{ item.LegalPerson }}
            </div>
            <div class="list-item">
              {{ $t.businessEntity.registeredCapital }}：{{ item.RegisteredCapital }}
            </div>
            <div class="list-item">{{ $t.businessEntity.remark }}：{{ item.Remark }}</div>
            <div class="list-item">
              {{ $t.businessEntity.status }}：<span v-if="item.Status == 1">{{
                $t.businessEntity.option1
              }}</span
              ><span v-if="item.Status == -1">{{ $t.businessEntity.option2 }}</span>
            </div>
          </div>
          <div class="right">
            <div class="images">
              <van-image
                width="88"
                height="88"
                fit="cover"
                @click="imagePreview(imgUrlFilter(item.CompanyLogo))"
                :src="imgUrlFilter(item.CompanyLogo)"
                v-if="item.CompanyLogo"
              />
              <span v-else>{{ $t.businessEntity.noImage }}</span>
            </div>
          </div>
          <div class="buttons">
            <van-button
              :class="item.Status == '1' ? 'default-btn' : 'search-btn'"
              size="small"
              type="primary"
              @click="updateBusinessEntityStatusByBEId(item)"
            >
              <span v-if="item.Status == '1'">{{ $t.meta.disable }}</span>
              <span v-else>{{ $t.meta.enable }}</span></van-button
            >

            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="gotoDetail(item.BEId)"
              >{{ $t.meta.editButton }}</van-button
            >
          </div>
        </div>
      </div>
    </van-list>
    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.businessEntity.status }}</div>
        <van-radio-group v-model="Status" direction="horizontal">
          <van-radio :name="1">{{ $t.businessEntity.option1 }}</van-radio>
          <van-radio :name="-1">{{ $t.businessEntity.option2 }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.businessEntity.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Image,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Image)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "businessEntitySettings",
  data() {
    return {
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      showFilter: false,
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.businessEntity.companyName,
          value: 1,
        },
        {
          text: this.$t.businessEntity.region,
          value: 2,
        },
      ],
      Status: null,
    };
  },
  created() {},
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    updateBusinessEntityStatusByBEId(item) {
      this.$commonMethod.showLoading();
      var param = {
        BEId: item.BEId,
        Status: item.Status == "1" ? -1 : 1,
      };
      this.$api.purchasingManagement
        .updateBusinessEntityStatusByBEId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "businessEntitySettingsDetail",
        name: "businessEntitySettingsDetail",
        query: [
          {
            name: "BEId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.Status) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.Status = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompanyName: this.searchType == 1 ? this.searchText : "",
        RegisteredRegion: this.searchType == 2 ? this.searchText : "",
        Status: this.Status,
      };
      this.$api.purchasingManagement
        .getBusinessEntityListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.businessEntitySettings {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      margin-top: 10px;
      font-size: 12px;
      color: #333;
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .left {
          vertical-align: middle;
          display: inline-block;
          width: 60%;
          .list-item {
            margin-bottom: 10px;
          }
          .list-item:last-child {
            margin-bottom: 0px;
          }
        }
        .right {
          vertical-align: middle;
          display: inline-block;
          width: 40%;
          .images {
            overflow: hidden;
            vertical-align: middle;
            text-align: center;
            ::v-deep img {
              border-radius: 8px;
            }
          }
        }
        .buttons {
          text-align: right;
          .primary-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
